import { render, staticRenderFns } from "./ProductAttributes.vue?vue&type=template&id=e612ed34&scoped=true"
import script from "./ProductAttributes.vue?vue&type=script&lang=ts"
export * from "./ProductAttributes.vue?vue&type=script&lang=ts"
import style0 from "./ProductAttributes.vue?vue&type=style&index=0&id=e612ed34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e612ed34",
  null
  
)

export default component.exports